//Generated File 
export default class ApplicationVersion{
	static readonly BUILD_DAY = 27;
	static readonly BUILD_HOUR = 23;
	static readonly BUILD_MINUTE = 13;
	static readonly BUILD_MONTH = 9;
	static readonly BUILD_YEAR = 2026;
	static readonly DATABASE_VERSION = 156;
	static readonly SERVER_VERSION = 7;
}
